/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShockEventUpdate
 */
export interface ShockEventUpdate {
    /**
     * The answer to the question: "Is the vehicle safe to drive after the medium impact shock?"
     * @type {boolean}
     * @memberof ShockEventUpdate
     */
    mediumImpactSafe: boolean;
}

/**
 * Check if a given object implements the ShockEventUpdate interface.
 */
export function instanceOfShockEventUpdate(value: object): value is ShockEventUpdate {
    if (!('mediumImpactSafe' in value) || value['mediumImpactSafe'] === undefined) return false;
    return true;
}

export function ShockEventUpdateFromJSON(json: any): ShockEventUpdate {
    return ShockEventUpdateFromJSONTyped(json, false);
}

export function ShockEventUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShockEventUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'mediumImpactSafe': json['mediumImpactSafe'],
    };
}

export function ShockEventUpdateToJSON(json: any): ShockEventUpdate {
    return ShockEventUpdateToJSONTyped(json, false);
}

export function ShockEventUpdateToJSONTyped(value?: ShockEventUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mediumImpactSafe': value['mediumImpactSafe'],
    };
}

